module.exports = __webpack_public_path__ + "static/Marta-1b66281957ef38f233aa0c1da2825849.jpg";